import { ACTIONS } from './constants';

const initialState = {
	activePaymentMethod: '',
	longId: null,
	env: null,
	sdkState: 'UNINITIALIZED',
	forceHostedFlow: true,

	/**
	 * A collection of component related data. Items in this object are keyed
	 * by the component name and created by the `reduceComponent()` function.
	 *
	 * @property {string} key - The component name.
	 * @property {Component} instance - The SDK component instance.
	 * @property {boolean} isMounted - Component is present in the DOM.
	 * @property {boolean} isReady - Component is fully rendered and usable.
	 * @property {boolean} isValid - Contains valid input, ready for payment.
	 */
	components: {},
};

const reduceComponent = ( state, componentName, updates ) => {
	const prevComponent = state.components[ componentName ] || {};

	return {
		...state.components, [ componentName ]: {
			key: componentName,
			instance: prevComponent.instance || null,
			isMounted: prevComponent.isMounted || false,
			isReady: prevComponent.isReady || false,
			isValid: prevComponent.isValid || false,
			...updates
		}
	};
};

const reducer = ( state = initialState, { type, payload } ) => {
	switch ( type ) {
		case ACTIONS.SET_EXTENSION_DATA:
			return { ...state, extension: payload };
		case ACTIONS.SET_LONG_ID:
			return { ...state, longId: payload };
		case ACTIONS.SET_LIST_URL:
			return { ...state, listUrl: payload };
		case ACTIONS.SET_ENV:
			return { ...state, env: payload };
		case ACTIONS.SET_SDK:
			return { ...state, sdk: payload };
		case ACTIONS.SET_SDK_VERSION:
			return { ...state, sdkVersion: payload };
		case ACTIONS.SET_SDK_INTEGRITY:
			return { ...state, sdkIntegrity: payload };
		case ACTIONS.SET_SDK_STATE:
			return { ...state, sdkState: payload };
		case ACTIONS.SET_ACTIVE_PAYMENT_METHOD:
			return { ...state, activePaymentMethod: payload };
		case ACTIONS.SET_FORCE_HOSTED_FLOW:
			return { ...state, forceHostedFlow: payload };
		case ACTIONS.SET_ORDER_ID:
			return { ...state, orderId: payload };
		case ACTIONS.SET_LONG_ID_TO_CHARGE:
			return { ...state, longIdToCharge: payload };
		case ACTIONS.SET_ON_PAYMENT_UNSUCCESSFUL_NONCE:
			return { ...state, onPaymentUnsuccessfulNonce: payload };

		// Component handling.

		case ACTIONS.ADD_COMPONENT:
			return {
				...state,
				components: reduceComponent( state, payload.componentName, { instance: payload.instance } ),
			};
		case ACTIONS.REMOVE_COMPONENT: {
			const { [ payload.componentName ]: removed, ...components } = state.components;
			return { ...state, components };
		}
		case ACTIONS.SET_IS_VALID:
			return {
				...state,
				components: reduceComponent( state, payload.componentName, { isValid: payload.flag } ),
			};
		case ACTIONS.SET_IS_MOUNTED:
			return {
				...state,
				components: reduceComponent( state, payload.componentName, { isMounted: payload.flag } ),
			};
		case ACTIONS.SET_IS_READY:
			return {
				...state,
				components: reduceComponent( state, payload.componentName, { isReady: payload.flag } ),
			};
		default:
			return state;
	}
};

export default reducer;
